var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: "14.37261962890625",
        height: "29.3909912109375",
        viewBox: "0 0 14.37261962890625 29.3909912109375",
        fill: "none"
      }
    },
    [
      _c(
        "g",
        { attrs: { opacity: "1", transform: "translate(0 0)  rotate(0)" } },
        [
          _c(
            "g",
            { attrs: { opacity: "1", transform: "translate(0 0)  rotate(0)" } },
            [
              _c(
                "g",
                {
                  attrs: {
                    opacity: "1",
                    transform: "translate(0 0)  rotate(0)"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        opacity: "1",
                        transform: "translate(0 0)  rotate(0)"
                      }
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            opacity: "1",
                            transform: "translate(0 0)  rotate(0)"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "形状 19 拷贝 18",
                              "fill-rule": "evenodd",
                              fill: "url(#linear_icon_0)",
                              opacity: "1",
                              d: "M0 0ZM14.37 15.2L0 0L0 29.39L14.37 15.2Z"
                            }
                          }),
                          _c("path", {
                            attrs: {
                              id: "形状 19 拷贝 18",
                              "fill-rule": "evenodd",
                              fill: "url(#linear_icon_1)",
                              opacity: "1",
                              d:
                                "M1.02631 9.12134ZM7.18631 15.4113L1.02631 9.12134L1.02631 21.2813L7.18631 15.4113Z"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _c(
            "g",
            { attrs: { opacity: "1", transform: "translate(0 0)  rotate(0)" } },
            [
              _c(
                "g",
                {
                  attrs: {
                    opacity: "1",
                    transform: "translate(0 0)  rotate(0)"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        opacity: "1",
                        transform: "translate(0 0)  rotate(0)"
                      }
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            opacity: "1",
                            transform: "translate(0 0)  rotate(0)"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "形状 19 拷贝 18",
                              "fill-rule": "evenodd",
                              fill: "url(#linear_icon_2)",
                              opacity: "1",
                              d: "M0 0ZM14.37 15.2L0 0L0 29.39L14.37 15.2Z"
                            }
                          }),
                          _c("path", {
                            attrs: {
                              id: "形状 19 拷贝 18",
                              "fill-rule": "evenodd",
                              fill: "url(#linear_icon_3)",
                              opacity: "1",
                              d:
                                "M1.02631 9.12134ZM7.18631 15.4113L1.02631 9.12134L1.02631 21.2813L7.18631 15.4113Z"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "linear_icon_0",
                x1: "204.8545821077758%",
                y1: "50%",
                x2: "-10.328199919919708%",
                y2: "50%",
                gradientUnits: "objectBoundingBox"
              }
            },
            [
              _c("stop", {
                attrs: {
                  offset: "0",
                  "stop-color": "#FF9F1B",
                  "stop-opacity": "1"
                }
              }),
              _c("stop", {
                attrs: {
                  offset: "0.42676299810409546",
                  "stop-color": "#EA9219",
                  "stop-opacity": "0.8314"
                }
              }),
              _c("stop", {
                attrs: {
                  offset: "1",
                  "stop-color": "#80500E",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "linear_icon_1",
                x1: "204.82162819548%",
                y1: "50%",
                x2: "-10.31536174501996%",
                y2: "50%",
                gradientUnits: "objectBoundingBox"
              }
            },
            [
              _c("stop", {
                attrs: {
                  offset: "0",
                  "stop-color": "#FF9F1B",
                  "stop-opacity": "1"
                }
              }),
              _c("stop", {
                attrs: {
                  offset: "0.42676299810409546",
                  "stop-color": "#EA9219",
                  "stop-opacity": "0.8314"
                }
              }),
              _c("stop", {
                attrs: {
                  offset: "1",
                  "stop-color": "#FF9400",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "linear_icon_2",
                x1: "204.8545821077758%",
                y1: "50%",
                x2: "-10.328199919919708%",
                y2: "50%",
                gradientUnits: "objectBoundingBox"
              }
            },
            [
              _c("stop", {
                attrs: {
                  offset: "0",
                  "stop-color": "#FF9F1B",
                  "stop-opacity": "1"
                }
              }),
              _c("stop", {
                attrs: {
                  offset: "0.42676299810409546",
                  "stop-color": "#EA9219",
                  "stop-opacity": "0.8314"
                }
              }),
              _c("stop", {
                attrs: {
                  offset: "1",
                  "stop-color": "#80500E",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "linear_icon_3",
                x1: "204.82162819548%",
                y1: "50%",
                x2: "-10.31536174501996%",
                y2: "50%",
                gradientUnits: "objectBoundingBox"
              }
            },
            [
              _c("stop", {
                attrs: {
                  offset: "0",
                  "stop-color": "#FF9F1B",
                  "stop-opacity": "1"
                }
              }),
              _c("stop", {
                attrs: {
                  offset: "0.42676299810409546",
                  "stop-color": "#EA9219",
                  "stop-opacity": "0.8314"
                }
              }),
              _c("stop", {
                attrs: {
                  offset: "1",
                  "stop-color": "#FF9400",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }